import { useWindowManager } from "./WindowManager";
import { calculateCenterPosition } from "./utils";
import ModalContent from "../components/ModalContent/ModalContent";
import { ModalContentButtonsContainer } from "../components/ModalContent/ModalContentStyles";
import MSButton from "../../../components/MSButton/MSButton";
import { playError } from "../../../utils/sound";

interface DialogButton {
  label: string;
  onClick?: () => void;
}

interface DialogOptions {
  windowTitle: string;
  title?: string;
  content: React.ReactNode;
  icon?: string;
  // defaults to a single OK button
  buttons?: DialogButton[];
  silent?: boolean;
}

// In-OS replacement for window.alert / window.confirm: opens a small draggable
// dialog window with the error "ding". Every button closes the dialog.
export const useDialog = () => {
  const { openWindow, closeWindow } = useWindowManager();

  return ({
    windowTitle,
    title,
    content,
    icon,
    buttons,
    silent,
  }: DialogOptions) => {
    if (!silent) playError();
    const dialogButtons = buttons?.length ? buttons : [{ label: "OK" }];
    let windowId = "";
    windowId = openWindow({
      windowTitle,
      icon,
      position: calculateCenterPosition(380, 160),
      isMinimized: false,
      isMaximized: false,
      component: (
        <ModalContent
          title={title}
          content={content}
          buttonsType="custom"
          onActionButtonClick={() => closeWindow(windowId)}
          buttons={
            <ModalContentButtonsContainer>
              {dialogButtons.map((button) => (
                <MSButton
                  key={button.label}
                  onClick={() => {
                    closeWindow(windowId);
                    button.onClick?.();
                  }}
                >
                  {button.label}
                </MSButton>
              ))}
            </ModalContentButtonsContainer>
          }
        />
      ),
    });
  };
};
